<section class="platform-businesses-connect">
  <div class="layout">
    <ng-container *ngFor="let connect of ConnectionList">
      <div class="left-sidebar">
        <div class="header-content mobile">
          <button [ngClass]="{ 'status-toggle': true, active: connect.data.isActive?.iv === 'Active' }">
            <div class="status-indicator">
              <span>{{ connect.data.isActive?.iv }}</span>
            </div>
          </button>
          <h1 class="header-title">
            {{ connect.data.title?.iv }}
          </h1>
        </div>
        <div>
          <div class="left-sidebar__logo">
            <img
              src="{{ connect.data.figure?.iv }}"
              alt="partner-firm-place-logo"
              width="100%"
              loading="lazy"
              class="left-sidebar__logo-image"
            />
          </div>
        </div>
      </div>

      <div class="detail-box">
        <div class="header">
          <div class="header-content desktop">
            <button [ngClass]="{ 'status-toggle': true, active: connect.data.isActive?.iv === 'Active' }">
              <div class="status-indicator">
                <span>{{ connect.data.isActive?.iv }}</span>
              </div>
            </button>
            <h1 class="header-title">
              {{ connect.data.title?.iv }}
            </h1>
          </div>
          <div class="header-description" [innerHTML]="connect.data.description?.iv"> </div>

          <div class="header-remarks" *ngIf="connect.data.headerRemark?.iv" [innerHTML]="connect.data.headerRemark?.iv">
          </div>
        </div>

        <div class="swiper-container-main">
          <ng-container *ngIf="connect.data.swiperImages?.iv">
            <swiper-container class="swiper" appSwiper [config]="config" init="false">
              <swiper-slide class="swiper-slide" *ngFor="let image of connect.data.swiperImages?.iv">
                <picture class="box__img desktop">
                  <img src="{{ image.url }}" class="box__img--layout" loading="lazy" [alt]="connect.data.alt?.iv" />
                </picture>
              </swiper-slide>
            </swiper-container>
          </ng-container>
        </div>

        <div class="benefit-container" *ngIf="connect.data.benefitTitle?.iv">
          <h3 class="benefit-title">{{ connect.data.benefitTitle?.iv }}</h3>
          <div
            class="benefit-list-container"
            *ngIf="connect.data.benefitList?.iv"
            [innerHTML]="connect.data.benefitList?.iv"
          >
          </div>
        </div>

        <div class="condition" *ngIf="connect.data.conditionTitle?.iv">
          <h3 class="condition-title">{{ connect.data.conditionTitle?.iv }}</h3>
          <ol
            class="condition-list-container"
            *ngIf="connect.data.conditionList?.iv"
            [innerHTML]="connect.data.conditionList?.iv"
          ></ol>
          <div
            class="condition-remark-container"
            *ngIf="connect.data.conditionRemark?.iv"
            [innerHTML]="connect.data.conditionRemark?.iv"
          ></div>
          <div
            class="form-register-container"
            *ngIf="connect.data.formRegister?.iv"
            [innerHTML]="connect.data.formRegister?.iv"
          >
          </div>

          <div class="href" *ngIf="connect.data.linkToMoreDetail?.iv">
            <span class="href-nameUrl-right">
              <a
                href="{{ connect.data.linkToMoreDetail?.iv }}"
                class="routerLink-color"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span class="nameUrl-text-link">
                  {{ 'PLATFORM_BUSINESSES.CONNECTION_TAB_TYPE.LEARN_MORE' | translate }}
                </span>
                <i class="fas fa-angle-right right" aria-hidden="true"></i>
              </a>
            </span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>
